exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".break-btn-icon[data-v-56a68746] {\n  margin-left: 3px;\n  margin-right: 3px;\n}\n.body-list[data-v-56a68746] {\n  padding-top: 0px;\n  position: relative;\n}\n.custom-toolbar[data-v-56a68746] {\n  margin-top: 0px;\n}\n.content[data-v-56a68746] {\n  margin-top: -15px;\n}\n.content[data-v-56a68746]  .md-card.md-theme-default {\n    margin-bottom: 0;\n}\n.card-icon-text[data-v-56a68746] {\n  color: white;\n}\n", ""]);

// exports
